<template>
  <div
    class="switch overflow-hidden"
    :class="[{ 'switch--enabled': modelValue }, $attrs.class]"
  >
    <label
      data-grid
      class="switch__wrapper grid--va-center justify-content-between w-100 h-100 cursor-pointer"
    >
      <strong class="switch__label flex-1 text-center">
        {{ currentLabel }}
      </strong>

      <span class="switch__toggle d-block p-relative">
        <input
          type="checkbox"
          :checked="switchValue"
          :name="name"
          :value="(switchValue | 0)"
          @change.prevent="getElementValue"
        >

        <span class="switch__ball d-block p-absolute" />
      </span>
    </label>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ToggleSwitch',

  inheritAttrs: false,

  props: {
    onText: {
      type: String,
      default: () => 'ON'
    },

    offText: {
      type: String,
      default: () => 'OFF'
    },

    modelValue: {
      type: [Boolean, Number],
      default: () => false
    },

    name: {
      type: String,
      default: () => ''
    }
  },

  emits: ['update:modelValue'],

  computed: {
    currentLabel () {
      const { modelValue, onText, offText } = this

      return modelValue ? onText : offText
    },

    switchValue: {
      get () {
        return !!this.modelValue
      },

      set (v) {
        this.$emit('update:modelValue', !!v)
      }
    }
  },

  methods: {
    getElementValue (e) {
      const { checked } = e.target

      this.switchValue = checked
    }
  }
})
</script>

<style lang="scss" scoped>
  .switch {
    $this: &;

    width: 105px;
    height: 40px;
    flex: 0 0 105px;
    border-radius: 40px;
    background-color: rgb(var(--gray15));

    ::selection {
      display: none;
    }

    &--enabled {
      background-color: rgb(var(--blue1));

      #{$this}__toggle {
        background-color: var(--primary);
      }
    }

    &,
    &__toggle {
      transition: all .4s ease-in-out;
    }

    &__wrapper {
      padding: 10px 11px;
    }

    &__label {
      letter-spacing: 0.05rem;
      color: rgb(var(--gray1));
      font: 700 1.4rem / 1.8rem "Nunito", sans-serif;
    }

    &__toggle {
      --parentWidth: 35px;

      width: var(--parentWidth);
      height: 20px;
      border-radius: 40px;
      background-color: rgb(var(--gray13));

      [type="checkbox"] {
        width: 1px;
        height: 1px;
        opacity: 0;
      }
    }

    &__ball {
      --width: 12px;
      --externalSpace: 4px;

      left: var(--externalSpace);
      top: calc(50% - (var(--width) / 2));
      width: var(--width);
      height: var(--width);
      border-radius: 50%;
      transition: all .15s ease-in-out;
      background-color: rgb(var(--white));

      :checked + & {
        transform: translateX(calc(var(--parentWidth) - var(--width) - var(--externalSpace) * 2));
      }
    }
  }
</style>
